import YourBusinessNetwork from "@/models/YourBusinessNetwork";
import {getBusinessCardsDoc, getYourBusinessNetworkDoc} from "@/shared/firebase_utils";
const state = {
  currentBusinessNetwork: null,
  registrants: []
};

const getters = {
  currentBusinessNetwork: (state) => state.currentBusinessNetwork,
  registrants: (state) => state.registrants,
};

const actions = {
  async setCurrentBusinessNetwork({ commit }, payload) {
    await commit("setCurrentBusinessNetwork", payload);
  },
  async initializeEvent({ commit }, id) {
    try {
      //Read data from firestore

      let doc = await getYourBusinessNetworkDoc(id);

      commit("setCurrentBusinessNetwork", YourBusinessNetwork.fromFireStore(doc));
    } catch (error) {
      console.log("Error initializing your business network: ", error);
    }
  },
  clearCurrentBusinessNetwork({commit}){
    commit("clearCurrentBusinessNetwork");
  },
  getRegistrants({ commit },attendees){

    let linkRegistrants = [];
    attendees.forEach((attendee) => {
      if (attendee.businessCardId != "") {
        let isBusinessCardRetrieved = false;

        for (let i = 0; i < linkRegistrants.length; i++) {
          if (linkRegistrants[i].id == attendee.businessCardId) {
            isBusinessCardRetrieved = true;
            break;
          }
        }

        if (!isBusinessCardRetrieved) {
          getBusinessCardsDoc(attendee.businessCardId)
            .then((doc) => {
              if (doc.exists)
                linkRegistrants.push({
                  id: doc.id,
                  ...attendee,
                  invitedEmail: attendee.email,
                  attendeeUid: attendee.uid,
                  ...doc.data(),
                });
            });
        }
      }
    });

    //Remove attendee from linkRegistrants
    linkRegistrants.forEach((registrant, index) => {
      let isRegistrantRemoved = true;

      for (let i = 0; i < attendees.length; i++) {
        if (registrant.id == attendees[i].businessCardId) {
          isRegistrantRemoved = false;
          break;
        }
      }

      if (isRegistrantRemoved) linkRegistrants.splice(index, 1);
    });

    commit("setRegistrants",linkRegistrants);
  }
};

const mutations = {
  setCurrentBusinessNetwork: (state, currentBusinessNetwork) => {
    state.currentBusinessNetwork = currentBusinessNetwork;
  },
  clearCurrentBusinessNetwork: (state) => {
    state.currentBusinessNetwork = null;
  },
  setRegistrants: (state, registrants) => {
    state.registrants = registrants;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
